<template>
  <div>
    <v-card>
      <v-flex xs12>                
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-right">
            <v-chip
              outline color="primary"
              v-if="showComponentsEmailSurvey && currentRound.status"
            >
              Last send: {{ currentRound.last_send ? currentRound.last_send : currentRound.start_date }}
            </v-chip>
            <v-btn
              round
              outline color="primary"
              :href="urlReports"
              target="_blank"
              v-if="currentRound.status"
            >
              <v-icon dark>mdi-wrench</v-icon>
                Show reports
              <v-icon class="ml-2">insert_chart_outlined</v-icon>
            </v-btn>
            <v-btn
              round
              outline
              color="primary"
              :href="newReportUrl"
              target="_blank"
              v-if="showComponentsDevicesSurvey && currentRound.status"
            >
              View new report
              <v-icon class="ml-2">dashboard</v-icon>
            </v-btn>
            <v-btn
              round
              outline color="primary"
              :href="urlExcel"
              target="_blank"
              v-if="currentRound.status"
            >
              <v-icon dark>mdi-wrench</v-icon>
              Download data
              <v-icon class="ml-2">get_app</v-icon>
            </v-btn>
            <v-chip outline color="green" large v-if="currentRound.status"> ACTIVE </v-chip>
          </v-flex>
          <v-flex xs12 class="pt-0 mt-0 text-xs-right">
            <v-chip outline color="primary">
              Identifier: {{ currentRound.id }}
            </v-chip>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <hr/>
            <stats-devices
              :round_id="currentRound.id"
              v-if="showComponentsDevicesSurvey && currentRound.status"
               v-on:dates="getDates"
            ></stats-devices>
            <stats-mailing
              :round_id="currentRound.id"
              v-if="showComponentsEmailSurvey && currentRound.status"
            ></stats-mailing>
          </v-flex>
          
        </v-layout>
        <hr>
        <v-flex xs12 class="pt-0 mt-0 text-xs-right" v-if="currentRound.status">
            <v-chip outline color="primary" v-if="currentRound.last_reminder">
              Last reminder: {{ currentRound.last_reminder }}
            </v-chip>
            <v-btn
              v-if="showComponentsEmailSurvey && currentRound && currentRound.status"
              color="primary"
              @click="showModal.sendReminder = true"
              :disabled="!currentRound.template_reminder"
            >
              send reminder
            </v-btn>
          </v-flex>
        
        <v-expansion-panel expand v-model="panelGeneral">
          <v-expansion-panel-content>
            <template slot="header">
              <div><v-icon class="ml-0">query_builder</v-icon> General</div>
            </template>
            <v-card>
              <v-container grid-list-xl fluid>
                <v-layout row wrap>
                  <v-flex xs12>                  
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field 
                          v-model="round.name" 
                          label="Name"
                          @input="updateRound"
                          :disabled="round.status"
                        ></v-text-field>
                        <date-picker-custom
                          :title="'Start date'"
                          :date="round.start_date"
                          :status="round.status"
                          @update-date="updateStartDate"
                        />
                        <v-textarea 
                          rows="1"
                          v-model="round.description"
                          label="Description"
                          :disabled="round.status" 
                          @input="updateRound"
                        ></v-textarea>
                        <v-switch
                          v-model="round.ip_configuration"
                          @change="updateRound"
                          :label="`Ip Configuration: ${round.ip_configuration ? 'active' : 'inactive'}`"
                          :disabled="round.status"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs6>
                        <v-select
                          v-model="round.type"
                          :items="itemsTypeRound"
                          item-text="text"
                          item-value="value"
                          label="Select type of Flow"
                          @input="updateRound"
                          :readonly="round.status"
                        ></v-select>
                        <date-picker-custom
                          :title="'End date'"
                          :date="round.end_date"
                          :status="round.status"
                          @update-date="updateEndDate"
                        />
                        <v-text-field 
                          v-model="round.time_reminder"
                          label="Reminder"
                          :disabled="round.status"
                          @input="updateRound"
                          v-if="showComponentsEmailSurvey"
                        ></v-text-field>
                        <v-switch
                          v-model="round.auto_refresh"
                          @change="updateRound"
                          :label="`Auto refresh: ${round.auto_refresh ? 'active' : 'inactive'}`"
                          :disabled="round.status"
                          v-else
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content>
              <template slot="header">
                <div><v-icon class="ml-0">settings</v-icon> Configuration</div>
              </template>
              <v-card>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex xs12 >                  
                        <v-layout row wrap v-if="showComponentsEmailSurvey">
                          <v-flex xs12>
                            <v-text-field 
                              v-model="round.subject_email" 
                              label="Email Subject" 
                              @input="updateRound"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="round.from_email"
                              label="Sender's Email Adresses"
                              placeholder="me@example.com"
                              @input="updateRound"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="round.name_from_email"
                              label="Sender's Name"
                              placeholder="John Doe"
                              @input="updateRound"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-text-field
                              v-model="round.message_success"
                              label="Message for survey answered"
                              :disabled="round.status"
                              placeholder="¡Survey answered successfully!"
                              @input="updateRound"
                            ></v-text-field>
                            <v-text-field
                              v-model="round.message_answered"
                              label="Message for survey has already been answered"
                              :disabled="round.status"
                              placeholder="¡Survey has already been answered!"
                              @input="updateRound"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="round.message_sub"
                              label="Subtitle for Messages"
                              :disabled="round.status"
                              placeholder="¡Thank you for your response!"
                              @input="updateRound"
                            ></v-text-field>
                            <v-text-field
                              v-model="round.message_expired"
                              label="Message for survey expired"
                              :disabled="round.status"
                              placeholder="¡Survey Expired!"
                              @input="updateRound"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                    </v-flex>
                  </v-layout>
              </v-container>
              </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="showComponentsDevicesSurvey && !showComponentsManager">
              <template slot="header">
                <div> <v-icon class="ml-0">devices</v-icon> Devices ({{ totalDevices }})</div>
              </template>
              <v-card>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex xs12 >                  
                      <v-layout row wrap>
                        <v-flex xs12>
                         <devices-select
                          :round_id="currentRound.id"
                          @update-devices="syncDevices"
                          @total-devices="updateTotalDevices"
                         />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
              </v-container>
              </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
              <template slot="header">
                <div><v-icon class="ml-0">question_answer</v-icon> Questions ({{ round.questions_ids.length }})</div>
              </template>
              <v-card>
                <v-flex v-if="round">
                  <questions-table
                    :round="round"
                    @update-question-selected="updatedQuestionSelected"
                  ></questions-table>
                </v-flex>
              </v-card>
          </v-expansion-panel-content>
           <v-expansion-panel-content v-if="round.type == 'advanced'">
              <template slot="header">
                <div><v-icon class="ml-0">format_list_numbered_rtl</v-icon> Question Flow</div>
              </template>
              <v-card>
                <v-flex v-if="round">
                  <questions-flow
                    :round="round"
                  >
                  </questions-flow>
                </v-flex>
              </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="showComponentsDevicesSurvey">
              <template slot="header">
                <div><v-icon class="ml-0">record_voice_over</v-icon> Personal Questions</div>
              </template>
              <v-card>
                <v-flex>
                  <personal-questions
                    :round="currentRound"
                  />
                </v-flex>
              </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="showComponentsDevicesSurvey && currentRound.status">
              <template slot="header">
                <div><v-icon class="ml-0">bar_chart</v-icon> Dashboard</div>
              </template>
              <v-card>
                <v-flex>
                  <dashboard-devices
                    v-if="showDasboard"
                    :round_id="currentRound.id"
                  ></dashboard-devices>
                </v-flex>
              </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="showComponentsEmailSurvey">
              <template slot="header">
                <div><v-icon class="ml-0">contact_mail</v-icon> Contacts ({{round.total_contacts}})</div>
              </template>
              <v-card>
               <v-flex>
                  <contacts-round-table
                    :round="currentRound"
                    @update-total-contacts="updateTotalContacts"
                  />
                </v-flex>
              </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      
    </v-card>

    <modal-send-reminder
        v-if="showModal.sendReminder"
        :round="currentRound"
        :showModal="showModal.sendReminder"
        @close-modal-send-reminder="showModal.sendReminder = false"
        @send-reminder="sendReminder()"
      ></modal-send-reminder>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DatePickerCustom from '@/components/client/rounds/commons/DatePickerCustom.vue';
import QuestionsTable from '@/components/client/questions/QuestionsTable.vue';
import PersonalQuestions from '@/components/client/questions/PersonalQuestions.vue';
import QuestionsFlow from '@/components/client/questions/QuestionsFlow.vue';
import DevicesSelect from '@/components/client/rounds/commons/DevicesSelect.vue';
import StatsMailing from '@/components/client/rounds/stats/StatsMailing.vue';
import StatsDevices from '@/components/client/rounds/stats/StatsDevices.vue';
import DashboardDevices from '@/components/client/rounds/dashboard/DashboardDevices.vue';
import ContactsRoundTable from '@/components/client/contacts/components/ContactsRoundTable.vue';
import ModalSendReminder from '@/components/client/rounds/modals/sendReminderConfirm.vue';
import lodash from 'lodash';

export default {
  components: {
    DatePickerCustom,
    QuestionsTable,
    StatsMailing,
    StatsDevices,
    DevicesSelect,
    PersonalQuestions,
    DashboardDevices,
    ContactsRoundTable,
    ModalSendReminder,
    QuestionsFlow
  },
  props: {
    round: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      date: null,
      showDasboard: false,
      startDateFilter: null,
      endDateFilter: null,
      panelGeneral: [true],
      totalDevices: 0,
      totalContacts: 0,
      showModal: {
        sendReminder: false,
      },
      itemsTypeRound: [
        { text: 'Standard', value: 'standard' },
        { text: 'Advanced', value: 'advanced' },
      ]
    };
  },
  computed: {
    ...mapGetters('survey', ['selectedSurvey']),
    ...mapGetters(['currentUser']),
    showComponentsManager: function () {
      if (this.currentUser.role === 'manager') {
        return true;
      }
      return false;
    },
    showComponentsEmailSurvey: function () {
      if (this.selectedSurvey.type === 'mailing' || this.selectedSurvey.type === 'extended' || this.selectedSurvey.type === 'custom') {
        return true;
      }
      return false;
    },
    showComponentsDevicesSurvey: function () {
      if (this.selectedSurvey.type === 'devices') {
        return true;
      }
      return false;
    },
    showComponentsLaboralSurvey: function () {
      return false;
    },
    currentRound: function () {
      return this.round;
    },
    urlReports: function () {
      if (this.selectedSurvey.type !== 'devices') {
        return `${process.env.SERVER_URL}/reports/survey/${this.selectedSurvey.id}/round/${this.currentRound.id}/traffic`;    
      } else {
        return `${process.env.SERVER_URL}/reports/devices/survey/${this.selectedSurvey.id}/round/${this.currentRound.id}/traffic?user=${this.currentUser.id}`;
      }
    },
    newReportUrl: function () {
      const routeData = this.$router.resolve({
        name: 'RoundNpsDashboard',
        params: {
          round_id: this.currentRound.id
        }
      });

      return routeData.href;
    },
    urlExcel: function () {
      if (this.selectedSurvey.type === 'mailing' || this.selectedSurvey.type === 'custom') {
        return `${process.env.API_URL}/round/${this.currentRound.id}/excelemails`;
      } else if (this.selectedSurvey.type === 'devices') {
        return `${process.env.API_URL}/round/${this.currentRound.id}/exceldevices?user=${this.currentUser.id}${this.startDateFilter != null && this.endDateFilter != null ? '&&start_date=' + this.startDateFilter + '&&end_date=' + this.endDateFilter : ''}`;
      } else if (this.selectedSurvey.type === 'extended' || this.selectedSurvey.type === 'labor') {
        return `${process.env.API_URL}/round/${this.currentRound.id}/extendedexcel`;
      }
    }
  },
  watch: {
    panelGeneral: function () {
      this.showDasboard = false;
      if (this.showComponentsDevicesSurvey && this.panelGeneral[this.panelGeneral.length - 1]) {
        this.showDasboard = true;
      }
    
    }
  },
  created: function () {
    this.surveyId = this.$route.params.survey_id;
    this.updateRound = lodash.debounce(this.updateRound, 2000);
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    updateRound () {
      const url = `rounds/${this.currentRound.id}`;
      const payload = {
        survey_id: this.selectedSurvey.id,
        survey_type: this.selectedSurvey.type,
        name: this.currentRound.name,
        end_date: this.currentRound.end_date,
        start_date: this.currentRound.start_date,
        description: this.currentRound.description,
        subject_email: this.currentRound.subject_email,
        name_from_email: this.currentRound.name_from_email,
        time_reminder: this.currentRound.time_reminder,
        from_email: this.currentRound.from_email,
        message_answered: this.currentRound.message_answered,
        message_success: this.currentRound.message_success,
        message_sub: this.currentRound.message_sub,
        message_expired: this.currentRound.message_expired,
        has_reminder: this.currentRound.has_reminder,
        auto_refresh: this.currentRound.auto_refresh,
        type: this.currentRound.type,
        ip_configuration: this.currentRound.ip_configuration
      };
      window.axios.put(url, payload).then(response => {
        this.setSnackbar({
          show: true,
          color: 'info',
          text: 'Round updated.'
        });
      });
    },
    syncDevices (values) {
      const url = `rounds/${this.currentRound.id}/associate-devices`;
      const payload = {
        devices: values,
        round: this.currentRound.id,
      };
      window.axios.put(url, payload).then(response => {
        this.totalDevices = response.data.devices.length;
        this.setSnackbar({
          show: true,
          color: 'info',
          text: 'Devices updated.'
        });
      });
    },
    updateTotalDevices (total) {
      this.totalDevices = total;
    },
    updateTotalContacts (total) {
      this.round.total_contacts = total;
    },
    updateStartDate (value) {
      this.currentRound.start_date = value;
      this.updateRound();
    },
    updateEndDate (value) {
      this.currentRound.end_date = value;
      this.updateRound();
    },
    updatedQuestionSelected (value) {
      this.currentRound.questions_ids = value;
    },
    sendReminder () {
      window.open(`${process.env.API_URL}/round/${this.currentRound.id}/template/round-reminder-send-manual`, '_blank');
    },
    getDates (data) {
      this.startDateFilter = data[0];
      this.endDateFilter = data[1];
    }
  }
  
  
};

</script>



// WEBPACK FOOTER //
// src/components/client/rounds/Show.vue